// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"59":"b3527b3cccc889f25506","635":"c30dc0ad885587220e7e"}[chunkId] + ".chunk.js";
};